import validationMessages from 'vee-validate/dist/locale/it';
// citrix.com/it-it

const yesNoOptions = [
    {value: "Yes", text: "Sì"},
    {value: "No", text: "No"}
]

export default {
    privacyLinkLabel: "Informativa sulla privacy.",
    privacyLink: '/it-it/about/legal/privacy/',
    privacyText: "Citrix tratterà i vostri dati in base alla nostra ",
    resetText: "Se il modulo è precompilato e i dati non sono i vostri,",
    resetText2: "per reimpostarli.",
    resetLinkText: "fate clic qui",
    yes: "Sì",
    no: "No",
    submitBtn: {
        "Submit" : "Inviate",
        "Get the eBook" : "Ottenete l’e-Book",
        "Watch demo" : "Watch demo",
        "Get the kit" : "Ottenete il kit",
        "Compare now" : "Confrontate ora",
        "Request a demo": "Richiedete una demo",
        "Request a call": "Richiedete di essere contattati"
    },
    apjPrivacy:{
        title: "In che modo utilizziamo le vostre informazioni personali",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") utilizzerà e archivierà le vostre informazioni personali in ottemperanza alle leggi e alle normative vigenti sulla protezione dei dati e all’",
        linkText: "informativa sulla privacy di Citrix",
        part2: ", nonché in circostanze di rigorosa limitazione degli accessi. Citrix utilizzerà le vostre informazioni personali solo come descritto dalla rispettiva informativa sulla privacy e mai per altri scopi. In conformità alla propria informativa sulla privacy, Citrix può affidare l’elaborazione delle informazioni personali ad aziende nazionali o estere, condividere informazioni personali con altri uffici o aziende consociate di Citrix in tutto il mondo o inviare le informazioni personali a terze parti nazionali o estere. Quando inviate le vostre informazioni personali a Citrix, acconsentite alla raccolta e all’elaborazione delle vostre informazioni personali come descritto nell’informativa sulla privacy di Citrix.",
        privacyAccept: "Ho letto e acconsento all’informativa sulla privacy di Citrix"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Azienda"
        },
        "department": {
            label: "Dipartimento",
            options: [
                { value: "Application Management", text: "Gestione delle applicazioni" },
                { value: "Consulting Services", text: "Servizi di consulenza" },
                { value: "Education / Training", text: "Formazione/training" },
                { value: "Engineering", text: "Ingegneria" },
                { value: "Executive Office / Administration", text: "Direzione/amministrazione" },
                { value: "Finance / Accounting", text: "Finanza/contabilità" },
                { value: "Human Resources", text: "Risorse umane" },
                { value: "Information Technology - Systems", text: "Sistemi IT" },
                { value: "Legal", text: "Informazioni legali" },
                { value: "Marketing / PR", text: "Marketing/PR" },
                { value: "Networking", text: "Networking" },
                { value: "Operations / Manufacturing", text: "Operazioni/fabbricazione" },
                { value: "Pre-Sales / Technical Support", text: "Supporto tecnico/pre-vendita" },
                { value: "Project Management", text: "Project management" },
                { value: "Purchasing", text: "Approvvigionamento" },
                { value: "Sales / Bus-Corp Development", text: "Commerciale/Sviluppo aziendale" },
                { value: "Security", text: "Sicurezza" },
                { value: "Web / Online / E-Business", text: "Web/online/e-business" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Settore",
            options: [
                { value: "Agriculture", text: "Agricoltura" },
                { value: "Hospitality", text: "Alberghiero" },
                { value: "Art & Membership", text: "Arte e associazioni culturali" },
                { value: "Insurance", text: "Assicurativo" },
                { value: "Consumer Packaged Goods", text: "Beni di consumo confezionati" },
                { value: "Chemical Manufacturing", text: "Chimica industriale" },
                { value: "Conglomerate", text: "Conglomerati" },
                { value: "Construction and Design", text: "Costruzioni e design" },
                { value: "E-Commerce", text: "e-Commerce" },
                { value: "Publishing/Printing", text: "Editoria/stampa" },
                { value: "Pharmaceuticals", text: "Farmaceutico" },
                { value: "Finance", text: "Finanza" },
                { value: "Service Provider", text: "Fornitore di servizi" },
                { value: "Oil and Gas", text: "Gas e petrolio" },
                { value: "Government/Local", text: "Governativo/locale" },
                { value: "Government/National-Federal", text: "Governativo/nazionale-federale" },
                { value: "Government/State-Province", text: "Governativo/statale-provinciale" },
                { value: "Real Estate", text: "Immobiliare" },
                { value: "Utilities", text: "Imprese di pubblica utilità" },
                { value: "Legal", text: "Informazioni legali" },
                { value: "Engineering", text: "Ingegneria" },
                { value: "Entertainment", text: "Intrattenimento" },
                { value: "Education", text: "Istruzione" },
                { value: "Manufacturing", text: "Manifatturiero" },
                { value: "Mining - All", text: "Minerario" },
                { value: "Charitable/Non-Profit", text: "Organizzazione filantropiche e non a scopro di lucro" },
                { value: "Health Care", text: "Sanità" },
                { value: "Business Consulting", text: "Servizi di consulenza per le imprese" },
                { value: "Personnel Services", text: "Servizi per il personale" },
                { value: "Household Services", text: "Servizi per la casa" },
                { value: "Business/Personal Services", text: "Servizi personali/aziendali" },
                { value: "Professional Services", text: "Servizi professionali" },
                { value: "Technology", text: "Tecnologia" },
                { value: "Telecommunication", text: "Telecomunicazioni" },
                { value: "Transportation", text: "Trasporti" },
                { value: "Retail/Wholesale", text: "Vendita al dettaglio/Vendita all'ingrosso" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Dimensioni dell'azienda",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Dimensioni dell'azienda",
            options: [
                { value: "5,001 +", text: "Più di 5.001" },
                { value: "1,001 to 5,000", text: "Da 1.001 a 5.000" },
                { value: "501 to 1,000", text: "Da 501 a 1.000" },
                { value: "251 to 500", text: "Da 251 a 500" },
                { value: "1 to 250", text: "Da 1 a 250" }
            ]
        },
        "Address2": {
            label: "Indirizzo riga 2"
        },
        "Address3": {
            label: "Indirizzo riga 3"
        },
        "city": {
            label: "Città"
        },
        "country": {
            label: "Paese"
        },
        "email": {
            label: "E-mail di lavoro"
        },
        "firstName": {
            label: "Nome"
        },
        "lastName": {
            label: "Cognome"
        },
        "phone": {
            label: "Numero di telefono"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "CAP/Codice di avviamento postale"
        },
        "salutation": {
            label: "Appellativo",
            options: [
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Stato/Provincia"
        },
        "address": {
            label: "Indirizzo"
        },
        "Job_Title__c": {
            label: "Qualifica",
            options: [
                { value: "Network Administrator / Engineer", text: "Amministratore di rete/ingegnere" },
                { value: "System Administrator", text: "Amministratore di sistema" },
                { value: "Analyst", text: "Analista" },
                { value: "Architect", text: "Architetto" },
                { value: "Assistant", text: "Assistente" },
                { value: "Business Manager", text: "Business manager" },
                { value: "Consultant", text: "Consulente" },
                { value: "Director", text: "Direttore" },
                { value: "C-Level / President / VP", text: "Presidente/vicepresidente/dirigente" },
                { value: "IT Manager", text: "Responsabile IT" },
                { value: "Student", text: "Studente" },
                { value: "Developer / Programmer", text: "Sviluppatore/programmatore" },
                { value: "Owner / Partner", text: "Titolare/socio" }
            ]
        },
        "Project_Budget__c": {
            label: "Budget per il progetto",
            options: [
                { value: "Yes", text: "Sì" },
                { value: "No", text: "No" },
                { value: "Unknown", text: "Sconosciuto" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "CTRL per selezionare più di una scelta (max 5 scelte)"
        },
        "Purchase_Timeframe__c": {
            label: "Tempistica di acquisto",
            options: [
                { value: "3 months or less", text: "3 mesi o meno" },
                { value: "4 to 6 months", text: "Da 4 a 6 mesi" },
                { value: "7 months or more", text: "7 mesi o più" },
                { value: "No time frame", text: "Non c'è una tempistica precisa" },
                { value: "Unknown", text: "Non saprei" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Possiamo inviarvi e-mail?",
            options: [
                { value: "Yes", text: "Sì" },
                { value: "No", text: "No" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Sì" },
                { value: "No", text: "No" }
            ]
        },
        "OK_to_Call__c": {
            label: "Possiamo chiamarvi per telefono?",
            options: [
                { value: "Yes", text: "Sì" },
                { value: "No", text: "No" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Fatemi contattare da un vostro responsabile commerciale"
        },
        "NumberofDesktops": {
            label: "Number of Desktops"
        },
        "NumberofServersGlobal": {
            label: "Quanti server gestite?",
            options: [
                { value: "1 SERVER", text: "1 SERVER" },
                { value: "2-5 SERVERS", text: "DA 2 A 5 SERVER" },
                { value: "6-10 SERVERS", text: "DA 6 A 10 SERVER" },
                { value: "11-50 SERVERS", text: "DA 11 A 50 SERVER" },
                { value: "51-100 SERVERS", text: "DA 51 A 100 SERVER" },
                { value: "> 100 SERVERS", text: "> 100 SERVER" }
            ]
        },
        "NumberofServersProject": {
            label: "Quanti server gestite?",
            options: [
                { value: "1 SERVER", text: "1 SERVER" },
                { value: "2-5 SERVERS", text: "DA 2 A 5 SERVER" },
                { value: "6-10 SERVERS", text: "DA 6 A 10 SERVER" },
                { value: "11-50 SERVERS", text: "DA 11 A 50 SERVER" },
                { value: "51-100 SERVERS", text: "DA 51 A 100 SERVER" },
                { value: "> 100 SERVERS", text: "> 100 SERVER" }
            ]
        },
        "Comments_6__c":{
            label: "Commenti"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Annullate l'iscrizione a tutte le comunicazioni e-mail di marketing.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Sospendete le comunicazione per 30 giorni.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "In che modo i workspace digitali completi, che comprendono applicazioni, desktop, file e dispositivi mobile, vi aiutano a svolgere il lavoro al meglio, ovunque.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "Come accedere in modo sicuro ad applicazioni, desktop e dati da qualsiasi dispositivo.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "Come gestire la distribuzione di applicazioni monolitiche e basate su microservizi in un mondo ibrido e multi-cloud.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "Come offrire una rete always-on e ad alte prestazioni necessaria ai vostri utenti.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "Come utilizzare analytics e insight per rilevare le minacce alla sicurezza e le anomalie delle prestazioni e bloccarle prima che si verifichino.",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "Annullate l’iscrizione",
        thankyou: "Le vostre preferenze per le e-mail sono state aggiornate. Se l’avete fatto per errore o desiderate rivedere le vostre preferenze, visitate il nostro Centro preferenze in qualsiasi momento.",
        formDescription: "Siamo spiacenti che abbiate annullato l’iscrizione. Ci auguriamo che torniate presto a visitare Citrix.com. Aggiungiamo costantemente nuove caratteristiche e funzionalità per assicurarci che i prodotti Citrix vi soddisfino.",

    },
    preferenceCenter: {
        formTitle: "Centro preferenze per le e-mail Citrix",
        thankyou: "<h3>Le modifiche all’iscrizione sono confermate!</h3><p>Le vostre preferenze per le e-mail sono state aggiornate.</p>",
        formDescription: "Le vostre preferenze per le e-mail e le comunicazioni sono importanti per noi. Desideriamo inviarvi informazioni che possano aiutare voi e la vostra organizzazione a promuovere un modo migliore di lavorare.  Aggiornate le vostre preferenze e-mail e faremo in modo che riceviate da Citrix comunicazioni pertinenti ai vostri interessi.",
        labelOne: "Forniteci maggiori informazioni su di voi",
        labelTwo: "Quali argomenti vi interessano maggiormente?",
        labelThree: "Quale modalità di comunicazione preferite?",
    },
    validation: validationMessages
}